import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { CreateContainer } from "../../components";

import Homelayout from "../../layout/Homelayout";
import {Home} from "../../pages";

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<Homelayout />}>
        <Route path="/*" element={<Home />} />
        <Route index element={<Home />} />
        <Route path="/createItem" element={<CreateContainer />} />
      </Route>
    </>
  )
);

const Routes = () => {
  return <RouterProvider router={router} />;
};

export default Routes;
